export default [
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("@/views/dashboard/analytics/Analytics.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/statistics-1",
    name: "statistics-1",
    component: () => import("@/views/dashboard/ecommerce/Ecommerce.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/statistics-2",
    name: "statistics-2",
    component: () => import("@/views/dashboard/ecommerce/Ecommerce.vue"),
    meta: {
      authRequired: true,
    },
  },
]
